import { BarController, BarElement, CategoryScale, Chart as ChartJs, Colors, Filler, Legend, LinearScale, LineController, LineElement, PointElement, SubTitle, Title as ChartJsTitle, Tooltip, } from "chart.js";
import zoomPlugin from "chartjs-plugin-zoom";
import { downloadFileName, getIcon } from "./HelpersFce";
import { saveAs } from "file-saver";
ChartJs.register(Colors, BarElement, CategoryScale, LinearScale, Legend, ChartJsTitle, SubTitle, Tooltip, BarController, LineController, BarElement, LineElement, PointElement, Filler, zoomPlugin);
export const onDownloadChartClick = (chart, filename) => {
    const toBlob = (base64) => {
        const matches = base64.match(/data:([^;]+);base64,/);
        if (!matches) {
            throw new Error("Invalid base64 string");
        }
        const mimeType = matches[1];
        // Odstranění "data:[<mime type>];base64," části z base64 řetězce
        const byteString = atob(base64.split(",")[1]);
        // Vytvoření pole typu Uint8Array s délkou byteString
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        // Naplnění Uint8Array byteStringem
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        // Vytvoření blobu z ArrayBuffer
        return new Blob([ab], { type: mimeType });
    };
    saveAs(toBlob(chart.toBase64Image()), filename);
};
export const onDownloadDataClick = (chart, filename) => {
    const dDataRR = [];
    for (let i = 0; i < chart.data.datasets.length; i++) {
        dDataRR[i] = {
            dataset: chart.data.datasets[i].label,
            x: chart.data.labels,
            y: chart.data.datasets[i].data,
        };
    }
    saveAs(new Blob([JSON.stringify(dDataRR)], {
        type: "application/json",
    }), filename);
};
export const onResetZoomClick = (chart) => {
    chart.resetZoom();
};
export class Chart {
    _loader;
    _downloadChartCallback;
    _downloadDataCallback;
    _resetZoomCallback;
    constructor(loader) {
        this._loader = loader;
    }
    _createCanvas(title, subTitle) {
        const div = document.createElement("div");
        div.style.position = "relative";
        this._loader.getElement().appendChild(div);
        const settings = this._loader.getSettings();
        const topRightDiv = document.createElement("div");
        topRightDiv.style.position = "absolute";
        topRightDiv.style.right = "0";
        div.appendChild(topRightDiv);
        const actionsDiv = document.createElement("div");
        actionsDiv.style.display = "grid";
        actionsDiv.style.gridAutoFlow = "column";
        actionsDiv.style.columnGap = "4px";
        topRightDiv.appendChild(actionsDiv);
        if (settings.download) {
            const downloadChart = document.createElement("div");
            downloadChart.innerHTML = getIcon("chart");
            downloadChart.style.cursor = "pointer";
            downloadChart.style.order = "3";
            const downloadData = document.createElement("div");
            downloadData.innerHTML = getIcon("data");
            downloadData.style.cursor = "pointer";
            downloadData.style.order = "2";
            actionsDiv.appendChild(downloadChart);
            actionsDiv.appendChild(downloadData);
            let ttl = "myChart";
            let subTtl = "";
            if (typeof title === "string")
                ttl = title;
            if (typeof subTitle === "string")
                subTtl = subTitle;
            const filename = downloadFileName(ttl, subTtl);
            downloadChart.addEventListener("click", () => {
                if (this._downloadChartCallback !== undefined) {
                    this._downloadChartCallback(filename);
                }
            });
            downloadData.addEventListener("click", () => {
                if (this._downloadDataCallback !== undefined) {
                    this._downloadDataCallback(filename);
                }
            });
        }
        if (settings.zoom) {
            const resetZoomBtn = document.createElement("div");
            resetZoomBtn.innerHTML = getIcon("zoom");
            resetZoomBtn.style.cursor = "pointer";
            resetZoomBtn.style.order = "1";
            actionsDiv.appendChild(resetZoomBtn);
            resetZoomBtn.addEventListener("click", () => {
                if (this._resetZoomCallback !== undefined) {
                    this._resetZoomCallback();
                }
            });
        }
        const canvas = document.createElement("canvas");
        return div.appendChild(canvas);
    }
    onDownloadChartClick(callback) {
        this._downloadChartCallback = callback;
    }
    onDownloadDataClick(callback) {
        this._downloadDataCallback = callback;
    }
    onResetZoomClick(callback) {
        this._resetZoomCallback = callback;
    }
    render() {
        const config = this._loader.getConfig();
        const chart = new ChartJs(this._createCanvas(config.options?.plugins?.title?.text, config.options?.plugins?.subtitle?.text), config);
        this.onDownloadChartClick((filename) => {
            onDownloadChartClick(chart, filename);
        });
        this.onDownloadDataClick((filename) => {
            onDownloadDataClick(chart, filename);
        });
        this.onResetZoomClick(() => {
            onResetZoomClick(chart);
        });
        return chart;
    }
}
//# sourceMappingURL=Chart.js.map